import { useCallback } from 'react';
import { useUtcDateTimeLazyQuery } from '@lingoda/monolith-graphql';

export const useApiTime = () => {
    const [fetchUtcTime] = useUtcDateTimeLazyQuery({ fetchPolicy: 'no-cache' });

    const fetchApiTime = useCallback(async () => {
        const response = await fetchUtcTime();

        return response.data?.utcDateTime;
    }, [fetchUtcTime]);

    return { fetchApiTime };
};
